import { UPDATE_COMPUTATION_DOCUMENT, SET_TAB_INDEX_COMPUTATION } from "../constants/computation";

const initialState = {
  computationDocument: undefined,
  tabIndex: 0
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TAB_INDEX_COMPUTATION:
      return {
        ...state,
        tabIndex: action.payload
      };
    case UPDATE_COMPUTATION_DOCUMENT:
      return {
        ...state,
        computationDocument: action.payload
      };
    default:
      return state;
  }
};
